/**
 * Structured data schemas for SEO
 */

// Organization schema
export const getOrganizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'EducationalOrganization',
  'name': 'CloudAI Leaders',
  'url': 'https://www.cloudaileaders.com',
  'logo': {
    '@type': 'ImageObject',
    'url': 'https://www.cloudaileaders.com/images/cloudaiicon.png',
    'width': '180',
    'height': '180'
  },
  'description': 'Expert-led training programs for Cloud Computing and AI technologies.',
  'sameAs': [
    'https://www.linkedin.com/company/cloudaileaders',
    'https://twitter.com/cloudaileaders',
    'https://www.facebook.com/cloudaileaders'
  ],
  'address': {
    '@type': 'PostalAddress',
    'addressLocality': 'San Francisco',
    'addressRegion': 'CA',
    'addressCountry': 'US'
  },
  'contactPoint': {
    '@type': 'ContactPoint',
    'contactType': 'customer service',
    'email': 'info@cloudaileaders.com',
    'availableLanguage': ['English']
  }
});

// Course schema
export const getCourseSchema = (course) => ({
  '@context': 'https://schema.org',
  '@type': 'Course',
  'name': course.title,
  'description': course.description,
  'provider': {
    '@type': 'Organization',
    'name': 'CloudAI Leaders',
    'sameAs': 'https://www.cloudaileaders.com'
  },
  'courseCode': course.id,
  'hasCourseInstance': {
    '@type': 'CourseInstance',
    'courseMode': course.mode || 'online',
    'duration': course.duration,
    'inLanguage': 'en'
  }
});

// FAQ schema
export const getFaqSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  'mainEntity': faqs.map(faq => ({
    '@type': 'Question',
    'name': faq.question,
    'acceptedAnswer': {
      '@type': 'Answer',
      'text': faq.answer
    }
  }))
});

// Breadcrumb schema
export const getBreadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  'itemListElement': items.map((item, index) => ({
    '@type': 'ListItem',
    'position': index + 1,
    'name': item.name,
    'item': item.url
  }))
});

// Article schema for blog posts
export const getArticleSchema = (article) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  'headline': article.title,
  'description': article.description,
  'image': article.image,
  'datePublished': article.publishDate,
  'dateModified': article.modifiedDate || article.publishDate,
  'author': {
    '@type': 'Person',
    'name': article.author
  },
  'publisher': {
    '@type': 'Organization',
    'name': 'CloudAI Leaders',
    'logo': {
      '@type': 'ImageObject',
      'url': 'https://www.cloudaileaders.com/images/cloudaiicon.png',
      'width': '180',
      'height': '180'
    }
  },
  'mainEntityOfPage': {
    '@type': 'WebPage',
    '@id': article.url
  }
});